import { createSelector } from 'reselect'

import { initialState, ProfileReducer } from '../reducers/domain'

const getProfile = (state: { profile: ProfileReducer }) => (state.profile && state.profile.data) || initialState.data

export default createSelector(getProfile, (profile) => ({
  location: profile.location || '',
  longitude: profile.longitude || '',
  town: profile.town || '',
  postcode: profile.postcode || '',
  latitude: profile.latitude || '',
  distance: profile.distance || 0,
}))
